<ep-employee-form
  [form]="employeeForm"
  [mode]="(mode$ | async)!"
  [accessTypeOptions]="accessTypeOptions"
  (addPin)="addPin()"
  (removePin)="removePin()"
></ep-employee-form>
